<template>

  <div v-if="currentUser !== null" class="mis-feedbacks">
    <headerFeed :currentUser="currentUser" title="Proceso de Feedback"></headerFeed>

    <md-layout md-gutter class="contenidoPagina">
      <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-align="center">
        <main>
          <h3 class="md-title"> Esperando Respuesta </h3>
          <md-spinner v-show="loader" md-indeterminate></md-spinner>
          <p v-if="feedPendientes.length === 0 && !loader">No tienes feedbacks esperando respuesta aun</p>
          <div v-for="feed in feedPendientes" :key="feed.key">
            <feedback @click.native="openDetail(feed)" :feedback="feed" :fluxer="feed.editor" :texto="getTitle(feed)"></feedback>
            <br>
          </div>
        </main>
      </md-layout>
      <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-align="center">
        <main>
          <h3 class="md-title"> Recibidos </h3>
          <md-spinner v-show="loader" md-indeterminate></md-spinner>
          <p v-if="feedFinalizados.length === 0 && !loader">No tienes Feedbacks finalizados aun</p>
          <div v-for="feed in feedFinalizados" :key="feed.key">
            <feedback @click.native="openDetail(feed)" :feedback="feed" :fluxer="feed.editor" :texto="getTitle(feed)"></feedback>
            <br>
          </div>
        </main>
      </md-layout>
    </md-layout>

    <md-speed-dial md-mode="scale" md-open="hover" class="md-fab-bottom-right">
      <md-button class="md-fab md-primary" md-fab-trigger>
          <md-icon md-icon-morph>close</md-icon>
          <md-icon>add</md-icon>
      </md-button>

      <md-button @click.native="confirmAutoeval('autoeval')" class="md-fab md-primary md-clean">
          <md-icon>person</md-icon>
          <md-tooltip md-direction="left">Reflexión personal</md-tooltip>
      </md-button>

      <md-button @click.native="openSelectFluxer('selectFluxer')" class="md-fab md-primary md-clean">
          <md-icon>swap_horiz</md-icon>
          <md-tooltip md-direction="left">Pedir feedback a un compañero</md-tooltip>
      </md-button>

      <md-button @click.native="openFeedLider('confirmFeedLider')" class="md-fab md-primary md-clean">
          <md-icon>arrow_downward</md-icon>
          <md-tooltip md-direction="left">Pedir feedback a mi lider</md-tooltip>
      </md-button>
    </md-speed-dial>

    <feedback-lider ref="confirmFeedLider" :currentFluxer="currentFluxer[0]"></feedback-lider>

    <feedback-companion ref="selectFluxer" :isEspontaneo="false" :currentFluxer="currentFluxer[0]"></feedback-companion>

    <md-dialog-confirm
      :md-title="'Crear una reflexion personal'"
      :md-content-html="'Se creará un feedback para escribir tu reflexión personal'"
      :md-ok-text="'Aceptar'"
      :md-cancel-text="'Cancelar'"
      @close="onConfirmAutoeval"
      ref="autoeval">
    </md-dialog-confirm>

    <md-snackbar :md-position="'bottom center'" ref="toastAutoeval" :md-duration="4000">
        <span>El feedback para realizar la reflexión personal se creó correctamente</span>
    </md-snackbar>

    <md-dialog-alert
      :md-title="''"
      :md-content="'No se puede ver el detalle de un feedback hasta que no sea enviado por quien lo esta escribiendo'"
      :md-ok-text="'Aceptar'"
      ref="advertencia">
    </md-dialog-alert>

    <router-view></router-view>

  </div>
</template>

<script>
import header from './Header'
import feedback from './Feedback'
import feedbackLider from './FeedbackLider'
import feedbackCompanion from './FeedbackCompanion'
import Router from '../router'
import FluxerService from '../services/fluxer'
import FeedbacksService from '../services/feedbacks'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'mis-feedbacks',
  components: {
    'headerFeed': header,
    'feedback': feedback,
    'feedback-lider': feedbackLider,
    'feedback-companion': feedbackCompanion
  },
  data () {
    return {
      loader: true,
      currentUser: FluxerService.getCurrentUser(),
      fluxer: ''
    }
  },
  computed: {
    feedPendientes: function () {
      // se muestran los pendientes posteriores al 7-11-2019
      let fechaCorte = moment('2019-11-7')
      return _.filter(this.misFeedbacks, function (f) {
        // retorna todos menos el espontaneo
        return moment(f.created).isAfter(fechaCorte) && !f.completed && !f.isEspontaneo
      })
    },
    feedFinalizados: function () {
      return _.filter(this.misFeedbacks, function (o) { return o.completed })
    }
  },
  firebase: function () {
    this.loader = true
    return {
      misFeedbacks: {
        source: FeedbacksService.getFeedbacksByOwner(this.currentUser.email),
        readyCallback: function () {
          this.loader = false
        }
      },
      currentFluxer: FluxerService.getFluxerByEmail(this.currentUser.email)
    }
  },
  methods: {
    openFeedLider (ref) {
      this.$refs[ref].confirmFeedLider()
    },
    openSelectFluxer (ref) {
      this.$refs[ref].open()
    },
    confirmAutoeval (ref) {
      this.$refs[ref].open()
    },
    onConfirmAutoeval (type) {
      if (type === 'ok') {
        FeedbacksService.create(this.currentUser, this.currentUser.email, 'autoeval').then((feedId) => {
          this.$refs.toastAutoeval.open()
        })
      }
    },
    openDetail (feedback) {
      if (!feedback.completed && feedback.editor !== this.currentUser.email) {
        return false
      }
      if (feedback.editor === this.currentUser.email || feedback.completed) {
        Router.push({name: 'mi-feedback-detail', params: {id: feedback['.key'], feedback: feedback, currentUser: this.currentUser}})
      } else {
        this.$refs['advertencia'].open()
      }
    },
    getTitle (feedback) {
      if (feedback.tipo === 'lider') {
        return 'Líder'
      } else if (feedback.tipo === 'autoeval') {
        return 'Reflexión Personal'
      } else if (feedback.tipo === 'companion') {
        return 'Fluxer'
      } else {
        return 'Espontáneo'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-fab.md-fab-bottom-right,
    .md-speed-dial.md-fab-bottom-right {
      position: fixed;
      right: 10px;
      bottom: 10px;
    }

    .add-button {
        width: 60px;
        height: 60px;
    }

  .contenidoPagina {
    padding-top: 64px;
  }
</style>



// WEBPACK FOOTER //
// MisFeedbacks.vue?435c2d14